import styled from '@tanium/react-emotion';
import { css } from '@tanium/style-system';
import { ThemeColors } from '@tanium/theme-data';

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
export const ErrorText = styled('p')(
  css({
    color: ThemeColors.Error,
    marginTop: 1,
    marginBottom: 2,
  })
);
